export default __webpack_public_path__ + "static/media/noto-sans-v12-latin-regular.bedd9dda.woff";